module.exports = __webpack_public_path__ + "img/northern-marianas-islands.29d2c3b2.svg";